'use strict';

// available config options: https://github.com/Modernizr/Modernizr/blob/master/lib/config-all.json
// documentation: https://modernizr.com/docs/

module.exports = {
    'classPrefix': 'mzr-',
    'options': [
        'setClasses'
    ],
    'feature-detects': [
        'test/css/flexbox',
        'test/cookies',
        'test/performance'
    ]
};